const productContent = document.getElementsByClassName(
  'product__content'
)[0];
const sprStarRating =
  document.getElementsByClassName('spr-starrating')[0];

if (!productContent && !sprStarRating) {
  if (productContent.classList.contains('text-center')) {
    sprStarRating.style.justifyContent = 'center';
  } else if (productContent.classList.contains('text-right')) {
    sprStarRating.style.justifyContent = 'flex-end';
  } else if (productContent.classList.contains('text-left')) {
    sprStarRating.style.justifyContent = 'flex-start';
  }
}

if (!customElements.get('product-sticky-atc')) {
  customElements.define(
    'product-sticky-atc',
    class ProductStickyAtc extends HTMLElement {
      constructor() {
        super();
      }

      connectedCallback() {
        const stickySubmit = this.querySelector('.product-selector__submit');
        if (!stickySubmit) return;

        this.productSection = this.closest('.product');
        if (!this.productSection) return;

        const ratingBadge = this.querySelector('.jdgm-prev-badge');
        const ratingStars = ratingBadge?.querySelector('.jdgm-prev-badge__stars');
        const averageRating = Number.parseFloat(ratingBadge?.dataset.averageRating);

        if (
          ratingStars &&
          Number.isFinite(averageRating) &&
          !this.querySelector('.vanan-sticky-atc__rating-average')
        ) {
          const average = document.createElement('span');
          average.className = 'vanan-sticky-atc__rating-average';
          average.textContent = averageRating.toFixed(1);
          ratingStars.after(average);
        }

        this.updateVisibility = () => {
          const triggerDistance = Math.min(180, window.innerHeight * 0.2);
          const shouldShow =
            this.productSection.getBoundingClientRect().top <= -triggerDistance;

          this.classList.toggle('is-visible', shouldShow);
          this.setAttribute('aria-hidden', shouldShow ? 'false' : 'true');
        };

        window.addEventListener('scroll', this.updateVisibility, { passive: true });
        window.addEventListener('resize', this.updateVisibility);
        this.updateVisibility();
      }

      disconnectedCallback() {
        window.removeEventListener('scroll', this.updateVisibility);
        window.removeEventListener('resize', this.updateVisibility);
      }
    }
  );
}
